import { createApp } from 'vue'
import App from './App.vue'
import { createHead } from '@vueuse/head'
import 'bootstrap/dist/css/bootstrap-grid.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import store from './assets/js/store.js';
import VueGoogleMaps from '@fawmi/vue-google-maps'

// 1. De
import router from './router'

import './registerServiceWorker'
const head = createHead()


createApp(App).use(head).use(store).use(router)
 .use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyDFxLyzzF-2xcQ-GjwBZv2rMySYMsn_dPw',
    },
  }).mount('#app')

